import '../IdcGlobal.IBP.Web/theme/US/site_1/css/royalslider.css'
import '../IdcGlobal.IBP.Web/theme/US/site_1/css/rs-default.css'
import '../IdcGlobal.IBP.Web/js/jquery.royalslider.min.js'